import React, { useState, useEffect } from "react";
import axios from "axios";
import { ClipLoader } from "react-spinners";
import { FaStar } from "react-icons/fa";
import { SERVER_URL } from "../../constants";
import {useUser} from '@clerk/clerk-react'
const CommentedProducts = () => {
  const [comments, setComments] = useState([]);
  const [loading, setLoading] = useState(true);
  const {user}=useUser()
  const userId=user.id

  useEffect(() => {
    const fetchCommentsAndProducts = async () => {
      try {
        // Fetch all comments by the user
        const response = await axios.get(`${SERVER_URL}/api/v1/comments/user/${userId}`);
        const userComments = response.data.data;

        // Fetch product details for each comment's productId
        const productsWithComments = await Promise.all(
          userComments.map(async (comment) => {
            const productResponse = await axios.get(
              `${SERVER_URL}/api/v1/product/${comment.productId}`
            );
            return {
              ...productResponse.data.data,
              comment: comment.comment,
              date: comment.createdAt,
            };
          })
        );

        setComments(productsWithComments);
      } catch (error) {
        console.error("Error fetching commented products:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchCommentsAndProducts();
  }, [userId]);

  const renderStars = (rating) => {
    return [...Array(5)].map((_, index) => (
      <FaStar
        key={index}
        className={index < rating ? "text-yellow-400" : "text-gray-300"}
      />
    ));
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center py-12">
        <ClipLoader size={50} color="#2563eb" />
      </div>
    );
  }

  return (
    <div className="p-6 bg-gray-50 rounded-lg shadow">
      <h2 className="text-2xl font-bold text-gray-800 mb-6">Your Reviewed Products</h2>

      {comments.length === 0 ? (
        <div className="text-center py-12">
          <p className="text-xl text-gray-600">No reviews given by you yet.</p>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {comments.map((product) => (
            <div
              key={product._id}
              className="bg-white rounded-xl shadow-lg overflow-hidden transform transition-all duration-300 hover:scale-105 hover:shadow-xl"
            >
              <div className="relative">
                <img
                  src={product.imgUrl[0] || "https://via.placeholder.com/150"}
                  alt={product.name}
                  className="w-full h-48 object-cover"
                />
              </div>
              <div className="p-6">
                <h3 className="text-xl font-semibold text-gray-800 mb-2">
                  {product.name}
                </h3>
               
                <p className="text-gray-600 mb-4 line-clamp-3">
                  {product.comment}
                </p>
                <div className="text-sm text-gray-500 flex justify-between items-center">
                  <span>{formatDate(product.date)}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default CommentedProducts;
